import styled from 'styled-components';
const blurred = 0.6;
export const Title = styled.p `
    color: ${(props) => (props.canAlreadyBeSkipped ? 'white' : 'rgba(255, 255, 255, 0.6)')};
    font-size: 15px;
    font-weight: 600;
    letter-spacing: -0.13px;
    padding: 10px;
    margin: 0;
    transition: all 0.4s ease;
`;
export const Button = styled.div `
    background: rgba(
        97,
        98,
        100,
        ${({ canAlreadyBeSkipped }) => (canAlreadyBeSkipped ? 1 : blurred)}
    );
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.4s ease;
    cursor: ${({ canAlreadyBeSkipped }) => (canAlreadyBeSkipped ? 'pointer' : 'auto')};
    pointer-events: auto;
`;
//# sourceMappingURL=index.js.map